import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import { Overlay } from '@thd-olt-component-react/overlay';
import './EtchVisualNavigationStory.scss';

const EtchVisualNavigationStory = (props) => {

  const opts = props?.opts;
  const {
    ctaLink,
    type,
    image,
    heading,
    subHeading,
    linkList,
    id
  } = opts;
  const [videoId, setVideoId] = useState(null);
  const [overlay, setOverlay] = useState(false);
  let callToActionLink = ctaLink;

  if (callToActionLink && callToActionLink.indexOf('playVideo') > -1) {
    callToActionLink = '#';
  }

  const onButtonClick = (event) => {
    if (ctaLink && ctaLink.indexOf('playVideo') > -1) {
      event.preventDefault();
      setVideoId(ctaLink?.match(/(\d+)/gm)?.[0])
      setOverlay(true);
    }
  }

  return (
    <>
      <div className="etchVisualNavigationStory etch-analytics" data-module-id={id} data-module-type={type}>
        <div className="etchVisualNavigationStory__container">
          <div className="etchVisualNavigationStory__card" data-module-content-id={id}>
            {callToActionLink
              && (
                <>
                  <a href={callToActionLink} onClick={onButtonClick}>
                    <img className="etchVisualNavigationStory__card__img" src={image?.src} alt={image?.alt} />
                  </a>
                  <a href={callToActionLink} className="etchVisualNavigationStory__card__title" onClick={onButtonClick}>
                    {heading}
                  </a>
                  <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                </>
              )}
            {!callToActionLink
              && (
                <>
                  <img className="etchVisualNavigationStory__card__img" src={image?.src} alt={image?.alt} />
                  <p className="etchVisualNavigationStory__card__title">{heading}</p>
                  <p className="etchVisualNavigationStory__card__description">{subHeading}</p>
                </>
              )}
            {linkList?.length > 0
              && (
                <ul className="etchVisualNavigationStory__link list list--type-plain" data-module-content-id={id}>
                  {linkList.map((link, index) => {
                    return (
                      <React.Fragment key={`${index}-${link.linkText}`}>
                        {
                          link.link
                        && (
                          <li className="list__item">
                            <a className="list__link" href={link.link}>{link.linkText}</a>
                          </li>
                        )
                        }
                        {
                          !link.link
                      && (
                        <li className="list__item">
                          {link.linkText}
                        </li>
                      )
                        }
                      </React.Fragment>
                    );
                  })}
                </ul>
              )}
          </div>
        </div>
      </div>
      {overlay && (
        <Overlay onClose={() => setOverlay(false)} open fit closeButton modalClass="etch-widgets__video-overlay__modal">
          <div className="etch-widgets__video-overlay">
            <VideoPlayer videoId={videoId} borderColor="black" autoPlay className="etch-widgets__video-overlay__player"/>
          </div>
        </Overlay>
      )}
    </>
  );
};

EtchVisualNavigationStory.displayName = 'EtchVisualNavigationStory';

EtchVisualNavigationStory.propTypes = {
  opts: PropTypes.shape({
    ctaLink: PropTypes.string,
    type: PropTypes.string,
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    linkList: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      linkText: PropTypes.string
    })),
    id: PropTypes.string
  })
};

EtchVisualNavigationStory.defaultProps = {
  opts: {}
};

export default EtchVisualNavigationStory;
